module.exports = __webpack_public_path__ + "static/cyber_security_for_web_developers_in_barcelona_code_school-9721bfca328828ac91632c9a10279714.png";